import { LoadingButton } from '../ui/LoadingSpinner';
import OmButton from '../ui/OmButton';
import OmTextField from '../ui/OmTextField';

const ClaimReviewModal = ({ 
  show, 
  onClose, 
  comments, 
  setComments, 
  onReview, 
  isReviewing 
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-carbon-black bg-opacity-60 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-0 border border-steel/20 w-96 shadow-depth bg-crystal-white">
        <div className="card-header">
          <h3 className="text-lg font-display font-semibold text-crystal-white">
            Review Claim
          </h3>
        </div>
        
        <div className="card-body space-y-6">
          <div>
            <OmTextField
              label="Review Comments"
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              rows={4}
              placeholder="Enter your review comments and observations..."
              supportingText={`Characters: ${comments.length}`}
              disabled={isReviewing}
            />
          </div>
          
          <div className="flex flex-col gap-2">
            <p className="text-sm text-steel">
              By recommending this claim for approval, you confirm that all required documents have been verified and the claim meets the criteria for approval.
            </p>
            <p className="text-sm text-steel">
              This claim will be marked as "Ready for Approval" and sent to an Approver for final decision.
            </p>
          </div>
        </div>
        
        <div className="card-footer flex justify-end space-x-4">
          <OmButton
            onClick={onClose}
            buttonType="text-button"
            buttonSize="medium"
            disabled={isReviewing}
          >
            Cancel
          </OmButton>
          <LoadingButton
            onClick={onReview}
            isLoading={isReviewing}
            className="btn-primary"
            loadingText="Submitting..."
          >
            Recommend for Approval
          </LoadingButton>
        </div>
      </div>
    </div>
  );
};

export default ClaimReviewModal;
